import request from '@/utils/request'

// role
export function createRbacRole(data) {return request({url: '/rbac/role/create',method: 'post',data})}
export function deleteRbacRole(data) {return request({url: '/rbac/role/delete',method: 'post',data})}
export function updateRbacRole(data) {return request({url: '/rbac/role/update',method: 'post',data})}
export function queryRbacRole(data) {return request({url: '/rbac/role/query',method: 'post',data})}
export function detailRbacRole(data) {return request({url: '/rbac/role/detail',method: 'post',data})}

// role resource
export function queryRbacRoleResource(data) {return request({url: '/rbac/role_resource/query',method: 'post',data})}
export function updateRbacRoleResource(data) {return request({url: '/rbac/role_resource/update',method: 'post',data})}

// role api tags
export function queryRbacRoleApiTags(data) {return request({url: '/rbac/role_api_tags/query',method: 'post',data})}
export function updateRbacRoleApiTags(data) {return request({url: '/rbac/role_api_tags/update',method: 'post',data})}

// resource
export function queryRbacResource(data) {return request({url: 'rbac/resource/query',method: 'post',data})}
export function createRbacResource(data) {return request({url: 'rbac/resource/create',method: 'post',data})}
export function updateRbacResource(data) {return request({url: 'rbac/resource/update',method: 'post',data})}
export function deleteRbacResource(data) { return request({ url: 'rbac/resource/delete', method: 'post', data }) }
export function queryRbacResourceTree(data) {return request({url: 'rbac/resource/tree',method: 'post',data})}

// api
export function queryRbacApi(data) {return request({url: 'rbac/api/query',method: 'post',data})}
export function createRbacApi(data) {return request({url: 'rbac/api/create',method: 'post',data})}
export function updateRbacApi(data) {return request({url: 'rbac/api/update',method: 'post',data})}
export function deleteRbacApi(data) { return request({ url: 'rbac/api/delete', method: 'post', data }) }
export function queryRbacApiTags(data) { return request({ url: 'rbac/api/query_tags', method: 'post', data }) }

// 临时授权
export function queryTempAuth(data) { return request({ url: '/rbac/temp_auth/query', method: 'post', data }) }
export function createTempAuth(data) { return request({ url: '/rbac/temp_auth/create', method: 'post', data }) }
export function updateTempAuth(data) { return request({ url: '/rbac/temp_auth/update', method: 'post', data }) }
export function deleteTempAuth(data) { return request({ url: '/rbac/temp_auth/delete', method: 'post', data }) }
export function detailTempAuth(data) { return request({ url: '/rbac/temp_auth/detail', method: 'post', data }) }

// user
export function login(data){return request({url:'/login',method:'post',data})}
export function userroleAdd(data){return request({url:'/userrole/add',method:'post',data})}
export function queryUserByRole(data){return request({url:'/userrole/list',method:'post',data})}
export function querySysUser(data){return request({url:'/rbac/user/list',method:'post',data})}
export function changePW(data){return request({url:'/rbac/user/changePassword',method:'post',data})}
export function createSysUser(data){return request({url:'/rbac/user/add',method:'post',data})}
export function updateSysUser(data){return request({url:'/rbac/user/edit',method:'post',data})}
export function deleteSysUser(data){return request({url:'/rbac/user/delete',method:'post',data})}
export function detailSysUser(data){return request({url:'/rbac/user/selectById',method:'post',data})}
export function queryOrgUserList(data){return request({url:'/rbac/user/org_user_list',method:'post',data})}